import * as React from "react";
import autoklawMiniImg from "../../../images/sprzet/autoklaw_mini.jpg";
import sterylnoscMiniImg from "../../../images/sprzet/sterylnosc_mini.jpg";
import fotelPodologicznyMiniImg from "../../../images/sprzet/fotel_podologiczny_mini.jpg";
import lampaPolimeryzacyjnaMiniImg from "../../../images/sprzet/lampa_polimeryzacyjna_mini.jpg";
import autoklawImg from "../../../images/sprzet/autoklaw.jpg";
import sterylnoscImg from "../../../images/sprzet/sterylnosc.jpg";
import fotelPodologicznyImg from "../../../images/sprzet/fotel_podologiczny.jpg";
import lampaPolimeryzacyjnaImg from "../../../images/sprzet/lampa_polimeryzacyjna.jpg";

const Equipment = () => {
    return (
        <div>
            <p className="text-center mb-0 pb-0" data-sal="slide-down" data-sal-delay="200" data-sal-duration="300">
                <h2 className="bb-primary mb-0 pb-2 d-inline-block ">Profesjonalny sprzęt medyczny</h2>
            </p>

            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4 py-5">
                <div className="col d-flex" data-sal="slide-right" data-sal-delay="200">
                    <img data-bs-toggle="modal" data-bs-target="#fotelPodologicznyModal" className="mx-auto img-fluid" src={fotelPodologicznyMiniImg} alt="Fotel podologiczny" />
                </div>
                <div className="col d-flex" data-sal="slide-down" data-sal-delay="300">
                    <img data-bs-toggle="modal" data-bs-target="#autoklawModal" className="mx-auto img-fluid" src={autoklawMiniImg} alt="Autoklaw" />
                </div>
                <div className="col d-flex" data-sal="slide-down" data-sal-delay="250">
                    <img data-bs-toggle="modal" data-bs-target="#sterylnoscModal" className="mx-auto img-fluid" src={sterylnoscMiniImg} alt="Sterylność" />
                </div>
                <div className="col d-flex" data-sal="slide-right" data-sal-delay="200">
                    <img data-bs-toggle="modal" data-bs-target="#lampaPolimeryzacyjnaModal" className="mx-auto img-fluid" src={lampaPolimeryzacyjnaMiniImg} alt="Lampa polimeryzacyjna" />
                </div>
            </div>

            <div className="modal fade" id="fotelPodologicznyModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Zamknij"></button>
                        </div>
                        <div className="modal-body">
                            <img loading="lazy" className="mx-auto img-fluid" src={fotelPodologicznyImg} alt="Fotel podologiczny" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="autoklawModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Zamknij"></button>
                        </div>
                        <div className="modal-body">
                            <img loading="lazy" className="mx-auto img-fluid" src={autoklawImg} alt="Autoklaw" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="sterylnoscModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Zamknij"></button>
                        </div>
                        <div className="modal-body">
                            <img loading="lazy" className="mx-auto img-fluid" src={sterylnoscImg} alt="Autoklaw" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="lampaPolimeryzacyjnaModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Zamknij"></button>
                        </div>
                        <div className="modal-body">
                            <img loading="lazy" className="mx-auto img-fluid" src={lampaPolimeryzacyjnaImg} alt="Autoklaw" />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default Equipment